import React from "react";


export default function Dashboard() {

	return (
		<div style={{ padding: 24, maxWidth: 1100, margin: "0 auto" }}>
			<h1 style={{ marginBottom: 16 }}>User Management</h1>
			<p>Manage system access, roles, and user details efficiently.</p>
		</div>
	);
}

